import type { Membresia, Navegacion, Operaciones, Yo } from '../api/operaciones';
import type { EntradaMenu } from '../logica/navegacion';

/**
 * Lo que recibe cada pantalla del panel (las de cada módulo, en `src/pantallas/<seccion>/`). Los permisos efectivos
 * llegan por `usePermisos()`, el aviso breve por `useAvisoBreve()` y el código de dos pasos en el momento por
 * `usePedirCodigoDosPasos()` (con `conDosPasosEnElMomento`). Los apartados propios de una pantalla van en
 * `?apartado=` (como en el prototipo), sin cambiar la ruta de su entrada del menú.
 */
export interface PropsPantalla {
    ops: Operaciones;
    /** Negocio activo (`biz_…`). */
    negocio: string;
    yo: Yo;
    /** La membresía de la persona en este negocio (no la hay con un acceso de plataforma). */
    membresia: Membresia | undefined;
    nombreNegocio: string;
    /** Negocio en solo lectura o Soporte sin permiso de escritura (G70, G114): sin botones de escribir. */
    soloLectura: boolean;
    movil: boolean;
    ruta: string;
    busqueda: URLSearchParams;
    navegar: (ruta: string, reemplazar?: boolean) => void;
    /** Vuelve a pedir la cuenta y el menú (tras cambiar algo que se ve en el marco: nombre, roles, negocio…). */
    recargar: () => void;
    /** La sesión ya no vale (401 sin poder renovarla): vuelta a entrar. */
    onSesionCaducada: () => void;
    /**
     * Las entradas que el servidor pone dentro de esta (`parent_key`, G130), en su orden y ya filtradas por permiso. Una
     * pantalla que pinta sus apartados (`PANTALLAS_CON_APARTADOS`) los saca de aquí, con su `badge` (G140, G141).
     */
    anidadas?: readonly EntradaMenu[];
    /**
     * Hay un acceso de plataforma abierto (Soporte o suplantación, `platform_access` de getMyNavigation, G137): sin los
     * botones que el servidor veta en ese caso aunque el permiso llegue (D-059: reembolsar, cobrar, conectar o desconectar
     * la cuenta de cobro).
     */
    accesoPlataforma?: boolean;
    /** Destinos de las referencias a otros módulos (`link_targets`, G298): úsalos con `enlaceDeReferencia`. */
    destinos?: Navegacion['link_targets'];
    /** Vuelve a leer la campana (su número sin leer) tras leer, archivar o silenciar avisos en «Tus avisos» (5.1). */
    recargarAvisos?: () => void;
}

/** Cambia el apartado de la pantalla (`?apartado=`) sin salir de su ruta. */
export function rutaConApartado(ruta: string, apartado: string | null): string {
    return apartado === null ? ruta : `${ruta}?apartado=${encodeURIComponent(apartado)}`;
}
